import Constants from 'api-constants'
/**
 * @class Nagra User entitlements
 * @documentation https://docs.nagra.com/doc/otv/otvdoc2051/apis/rights-manager-rmg-api-documentation#/User%20Entitlements%20Service%20(OPF%20Specific)/get_5
 */
export class UserEntitlement {
    constructor(props) {
        /** @type {String} */
        this.productId = props.productId
        /** @type {String} */
        this.status = props.status
        /** @type {String} */
        this.productType = props.productType
        /** @type {Date} */
        this.validFrom = this.parseDate(props.validFrom)
        /** @type {Date} */
        this.expiryDate = this.parseDate(props.expiryDate)
        /** @type {String} */
        this.transactionId = props._id
        /** @type {String} */
        this.accountId = props.accountId
        /** @type {String} */
        this.validityType = props.validityType
        /** @type {String} */
        this.purchasedOffer = props.purchasedOffer
        /** @type {Date} */
        this.created = this.parseDate(props.created)
        /** @type {Date} */
        this.modified = this.parseDate(props.modified)
        /** @type {Boolean} */
        this.isArchivable = props.isArchivable
        /** @type {Boolean} */
        this.isFreemium = props.isFreemium
    }

    static STATUS = {
        SUBSCRIBED: 'SUBSCRIBED',
        UNSUBSCRIBED: 'UNSUBSCRIBED',
    }

    static VALIDITY_TYPE = {
        ABSOLUTE: 'ABSOLUTE',
        RELATIVE: 'RELATIVE',
    }

    static PRODUCT_TYPE = {
        TRANSACTIONAL: 'TRANSACTIONAL',
        SUBSCRIPTION: 'SUBSCRIPTION',
        FREE: 'FREE',
        CAPABILITY: 'CAPABILITY',
    }

    isEntitled() {
        return this.status === UserEntitlement.STATUS.SUBSCRIBED
    }

    parseDate(str) {
        if (str && typeof str === 'string') {
            return new Date(str)
        }
        return str
    }

    static getProductType(productType) {
        switch (productType) {
            case Constants.productTypes.SUBSCRIPTION:
                return UserEntitlement.PRODUCT_TYPE.SUBSCRIPTION
            case Constants.productTypes.TRANSACTIONAL:
                return UserEntitlement.PRODUCT_TYPE.TRANSACTIONAL
            default:
                return undefined
        }
    }

    /**
     * To be used for Debug and log
     */
    toString() {
        return `status: ${this.status} || ProductId: ${this.productId} || expiryDate: ${this.expiryDate} || TransactionId: ${this.transactionId}`
    }
}
